import type { IConversation } from 'src/api/landlord-messages-api';
import { isConversation, type IConversationMatchWithChannel } from 'src/pages/landlord/conversations/context';
import type { ILead, IProperty } from 'src/services/api';

/**
 * Read a row's property out of the bulk `useProperties` cache instead of giving
 * the row its own observer.
 *
 * The lead owns the property. `conversation.property_id` is a denormalised copy
 * kept in sync by the live-update reconciler, and search matches do not carry it
 * at all, so it is only a fallback.
 */
export const resolveRowProperty = (
    conversation: IConversation | IConversationMatchWithChannel,
    lead: ILead | undefined,
    propertiesById: Map<number, IProperty>,
): IProperty | undefined => {
    const propertyId = lead?.property_id ?? (isConversation(conversation) ? conversation.property_id : null);
    return propertyId === null ? undefined : propertiesById.get(propertyId);
};
